import Swal from 'sweetalert2';
export const showSuccessAlert = async (error, title) => {
  const swalResult = await Swal.fire({
    title: title,
    text: error,
    icon: 'success',
    confirmButtonText: 'Okay',
    customClass: 'sweetalert-bootstrap-modal',
    timer: 2000,
    showConfirmButton: false
  });

  // If you want to perform some action after the alert is closed, you can check the result
  if (swalResult.dismiss === Swal.DismissReason.timer) {
    // console.log('Alert closed after the timer elapsed.');
    // Perform additional actions if needed
  }
};
